import { create } from 'zustand';
import { persist } from 'zustand/middleware';
const shopFields = (shop)=>({
        name: shop?.name || null,
        orgId: shop?.orgId ?? null,
        orgName: shop?.orgName ?? null,
        orgRole: shop?.orgRole ?? null,
        orgPlan: shop?.orgPlan ?? null,
        orgAudience: shop?.orgAudience ?? null,
        orgAwaitingPayment: shop?.orgAwaitingPayment ?? false,
        canManageShop: shop?.orgRole === 'owner' || shop?.orgRole === 'admin'
    });
export const useAuthStore = create()(persist((set)=>({
        token: null,
        userID: null,
        username: null,
        role: null,
        isAuthenticated: false,
        isAdmin: false,
        ...shopFields(),
        login: (token, userID, username, role, shop)=>set({
                token,
                userID,
                username,
                role,
                isAuthenticated: true,
                isAdmin: role === 'admin',
                ...shopFields(shop)
            }),
        setShopInfo: (shop)=>set((st)=>({
                    ...shopFields(shop),
                    ...shop.role ? {
                        role: shop.role,
                        isAdmin: shop.role === 'admin'
                    } : {},
                    ...shop.username ? {
                        username: shop.username
                    } : {
                        username: st.username
                    }
                })),
        logout: ()=>{
            set({
                token: null,
                userID: null,
                username: null,
                role: null,
                isAuthenticated: false,
                isAdmin: false,
                ...shopFields()
            });
            // Remove the persisted blob outright rather than leaving a record of
            // nulls behind: nothing about the previous user should remain in
            // localStorage once they are gone. (set() above already re-persisted,
            // so this runs after it.)
            useAuthStore.persist.clearStorage();
        }
    }), {
    name: 'full-on-kei-auth'
}));
